import React, { useState } from 'react';
import FilterIcon from '../../../icons/FilterIcon';
import PlusIcon from '../../../icons/PlusIcon';
import { Modal, Backdrop } from '@mui/material';
import DebouncedTextField from '../../../components/common/DebouncedTextField';
import TemplatesForm from './TemplatesForm';
import ContractTypeDropdown from '../../../components/ContractTypeDropdown';
export const defaultFilters = {
  name: '',
  contract_type: '',
};

const ActionBar = (props) => {
  const [showFilters, showHideFilters] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);

  const updateFilters = (newFilters) => {
    setFilters(newFilters);
    props.onFilterChange(newFilters);
  };

  const onNameChangeHandler = (name) => {
    updateFilters({ ...filters, name: name });
  };

  const onContractTypeChangeHandler = (contractType) => {
    updateFilters({ ...filters, contract_type: contractType });
  };

  return (
    <>
      <div className="page-actionbar-container">
        <div
          className="page-actionbar-item action-btn"
          onClick={() => showHideFilters(!showFilters)}
        >
          <FilterIcon />
        </div>
        <div
          className="page-actionbar-item action-btn"
          onClick={() => {
            props.setFormVisible(true);
          }}
        >
          <PlusIcon />
        </div>
        <div>
          <Modal
            size="lg"
            open={props.formVisible}
            onClose={() => props.setFormVisible(!props.formVisible)}
          >
            <div className="modal-container">
              <TemplatesForm
                setFormVisible={props.setFormVisible}
                onSaveTemplate={props.onSaveTemplate}
              />
            </div>
          </Modal>
        </div>
      </div>
      {showFilters ? (
        <div className="page-actionbar-container">
          <div className="page-filter-bar">
            <DebouncedTextField
              label="Nome do template"
              onChange={(value) => {
                onNameChangeHandler(value);
              }}
            />
          </div>
          <div className="page-filter-bar">
            <ContractTypeDropdown
              onChange={(value) => {
                onContractTypeChangeHandler(value.name);
              }}
            />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ActionBar;
